import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ILoadingOverlayAngularComp } from 'ag-grid-angular';
import { GridApi } from 'ag-grid-community';
import { ErrorComponentData } from '../../shared-models';
import { WindowUtilitiesService } from '../../shared-utilities';

export interface SubscriptionDetailsNoRowsOverlayAdditionalParams {
  api?: GridApi;
  name: string;
  namePlural: string;
  image: string;
  noResultsMessage?: string | null;
  showNoResultsMsg?: () => boolean;
  showLoadingMsg: () => boolean;
  showAdditionalMsg?: () => boolean;
  showSubscribedToAllMsg?: () => boolean;
  showNoMatchMsg?: () => boolean;
  showErrorMsg: () => boolean;
  getError: () => ErrorComponentData | null;
  loadData: () => null | void;
}

export type SubscriptionDetailsNoRowsOverlayParams = SubscriptionDetailsNoRowsOverlayAdditionalParams;

@Component({
  selector: 'grid-ui-subscription-details-norows-overlay',
  templateUrl: './subscription-details-norows-overlay.component.html',
  styleUrls: ['./subscription-details-norows-overlay.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SubscriptionDetailsNoRowsOverlayComponent implements ILoadingOverlayAngularComp {
  public params!: SubscriptionDetailsNoRowsOverlayParams;

  public get error() {
    return this.params.getError();
  }

  constructor(private readonly windowUtilitiesService: WindowUtilitiesService) {}

  public agInit(params: any): void {
    this.params = params;
  }

  public reloadApp(): void {
    this.windowUtilitiesService.reloadApp();
  }

  public showAdditionalMsg(): boolean {
    return !!this.params?.showAdditionalMsg && this.params?.showAdditionalMsg();
  }

  public showSubscribedToAllMsg(): boolean {
    return !!this.params?.showSubscribedToAllMsg && this.params?.showSubscribedToAllMsg();
  }

  public showNoResultMsg(): boolean {
    return !!this.params?.showNoResultsMsg && this.params?.showNoResultsMsg();
  }

  public showNoMatchMsg(): boolean {
    return !!this.params?.showNoMatchMsg && this.params?.showNoMatchMsg();
  }
}
